<div class="main-container">
  <div class="div-container">
    <h2>{{ title | translate }}</h2>
    <p>{{ text | translate }}</p>
  </div>
  <button *ngIf="hasButton" mat-raised-button (click)="redirectToApp()">{{ buttonText | translate }}</button>
</div>
